// Fashion till theme: store config first, then this till's saved choice,
// then Threadline.

export const FASHION_THEMES = ["threadline", "nordvik", "lune"];
export const DEFAULT_FASHION_THEME = "threadline";
export const THEME_KEY = "cw.fashion.theme";

export const normaliseTheme = (value) => {
  if (typeof value !== "string") return null;
  const name = value.trim().toLowerCase().replace(/^th-/, "");
  return FASHION_THEMES.includes(name) ? name : null;
};

const readStored = () => {
  try {
    return window.localStorage.getItem(THEME_KEY);
  } catch {
    return null;
  }
};

export function resolveFashionTheme({ posConfig, tillData } = {}) {
  const till = tillData?.tillAccess?.cwrTill || tillData?.cwrTill || tillData;
  return (
    normaliseTheme(posConfig?.fashionTheme) ||
    normaliseTheme(till?.fashionTheme) ||
    normaliseTheme(tillData?.fashionTheme) ||
    normaliseTheme(readStored()) ||
    DEFAULT_FASHION_THEME
  );
}

export const themeClass = (name) => `th-${normaliseTheme(name) || DEFAULT_FASHION_THEME}`;
